import { useMemo, useState } from 'react';

import { formatShortDate } from '../lib/format.js';

const CHART_HEIGHT = 176;
const PLOT_TOP = 12;
const PLOT_BOTTOM = 30;
const LEFT = 24;
const RIGHT = 16;

export default function DailyBars({ daily, series, empty }) {
  const [selectedDate, setSelectedDate] = useState(() => daily.at(-1)?.date);
  const max = Math.max(1, ...daily.flatMap((day) => series.map((item) => Number(item.value(day)) || 0)));
  const chartWidth = Math.max(620, daily.length * 76);
  const plotWidth = chartWidth - LEFT - RIGHT;
  const plotHeight = CHART_HEIGHT - PLOT_TOP - PLOT_BOTTOM;
  const selected = daily.find((day) => day.date === selectedDate) ?? daily.at(-1);
  const paths = useMemo(() => series.map((item) => ({
    ...item,
    points: daily.map((day, index) => {
      const value = Number(item.value(day)) || 0;
      return {
        x: LEFT + (daily.length === 1 ? plotWidth / 2 : (index / (daily.length - 1)) * plotWidth),
        y: PLOT_TOP + plotHeight - (value / max) * plotHeight,
        value,
      };
    }),
  })), [daily, max, plotHeight, plotWidth, series]);

  if (empty) return <div className="chart-empty"><span>本周期暂无相关记录</span></div>;

  return (
    <div className="chart-wrap" aria-label={`趋势图：${series.map((item) => item.label).join('、')}`}>
      <div className="chart-legend">
        {series.map((item) => <span key={item.label}><i style={{ background: item.color }} />{item.label}</span>)}
      </div>
      <div className="line-chart-viewport">
        <svg className="line-chart" viewBox={`0 0 ${chartWidth} ${CHART_HEIGHT}`} role="img">
          {[0, 0.5, 1].map((ratio) => {
            const y = PLOT_TOP + plotHeight * ratio;
            return <line key={ratio} x1={LEFT} x2={chartWidth - RIGHT} y1={y} y2={y} className="line-chart__grid" />;
          })}
          {paths.map((item) => <polyline key={item.label} points={item.points.map((point) => `${point.x},${point.y}`).join(' ')} fill="none" stroke={item.color} strokeWidth="3" strokeLinejoin="round" strokeLinecap="round" />)}
          {daily.map((day, index) => {
            const x = LEFT + (daily.length === 1 ? plotWidth / 2 : (index / (daily.length - 1)) * plotWidth);
            const labelVisible = daily.length <= 7 || index % 5 === 0 || index === daily.length - 1;
            return (
              <g key={day.date} className={`line-chart__day ${selected?.date === day.date ? 'is-selected' : ''}`} onClick={() => setSelectedDate(day.date)}>
                <rect x={x - Math.max(18, plotWidth / daily.length / 2)} y={0} width={Math.max(36, plotWidth / daily.length)} height={CHART_HEIGHT} fill="transparent" />
                {labelVisible ? <text x={x} y={CHART_HEIGHT - 8} textAnchor="middle">{formatShortDate(`${day.date}T00:00:00+08:00`)}</text> : null}
                {selected?.date === day.date ? <line x1={x} x2={x} y1={PLOT_TOP} y2={PLOT_TOP + plotHeight} className="line-chart__selection" /> : null}
              </g>
            );
          })}
        </svg>
      </div>
      {selected ? (
        <div className="line-chart-detail">
          <strong>{formatShortDate(`${selected.date}T00:00:00+08:00`)}</strong>
          {series.map((item) => <span key={item.label}><i style={{ background: item.color }} />{item.label}<b>{Number(item.value(selected)) || 0}{item.unit ? ` ${item.unit}` : ''}</b></span>)}
        </div>
      ) : null}
    </div>
  );
}
